import Component from '../abstracts/Component';
import brightcovePlayerLoader from '@brightcove/player-loader';

export default class PdpImagesComponent extends Component {

  get COMPONENTNAME() {
    return 'PdpImagesComponent';
  }

  get SELECTORS() {
    return {
      zoomTrigger: '[data-zoom-trigger]',
      zoomContainer: '[data-zoom-container]',
      zoomImage: '[data-zoom-image-selected]',
      zoomClose: '[data-trigger-close]',
      navigationTrigger: '[data-navigation-trigger]',
      productCarousel: '[data-js-product-carousel]',
      zoomNavigation: '[data-zoom-navigation]',
      zoomPrevArrow: '[data-prev-arrow]',
      zoomNextArrow: '[data-next-arrow]',
      videoPdp: '[data-video-pdp]',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  readDOM() {
    return {
      zoomTriggers: this.$component.querySelectorAll(this.SELECTORS.zoomTrigger),
      zoomContainer: this.$component.querySelector(this.SELECTORS.zoomContainer),
      zoomImage: this.$component.querySelector(this.SELECTORS.zoomImage),
      zoomClose: this.$component.querySelector(this.SELECTORS.zoomClose),
      navigationTriggers: this.$component.querySelectorAll(this.SELECTORS.navigationTrigger),
      productCarousel: this.$component.querySelector(this.SELECTORS.productCarousel),
      zoomNavigation: this.$component.querySelector(this.SELECTORS.zoomNavigation),
      zoomPrevArrow: this.$component.querySelector(this.SELECTORS.zoomPrevArrow),
      zoomNextArrow: this.$component.querySelector(this.SELECTORS.zoomNextArrow),
      videosPdp: this.$component.querySelectorAll(this.SELECTORS.videoPdp),
      activePicture: null,
    };
  }

  // MOBILE CAROUSEL //
  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        this.initCarousel();
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  initCarousel() {

    //rallentiamo l'esecuzione della funzione ogni volta che viene invocata debounce
    //esempio al resize, l'handler non viene eseguito in maniera instantanea ma aspettando il tempo indicato in ms
    //es. $(window).on('resize', debounce(() => {...},200));
    const debounce = (func, wait) => {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(context, args);
        }, wait);
      };
    };

    const slickSettings = {
      arrows: false,
      dots: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 767,
          settings: "unslick"
        }
      ],
      //non aspettano che le animazioni in corso finiscano, stoppiamo in maniera forzata
      waitForAnimate: false
    };

    let $productCarousel;
    const handleResize = debounce(() => {
      $productCarousel = $(this.dom.productCarousel);
      const isDesktop = $(window).width() > 1024;
      const isInitialized = $productCarousel.hasClass('slick-initialized');

      if (isDesktop && isInitialized) {
        $productCarousel.slick('setPosition');
        $productCarousel.slick('unslick');
      }
      else if (!isDesktop && !isInitialized) {
        $productCarousel.slick(slickSettings);
      }
      else if (!isDesktop && isInitialized) {
        // Aggiungiamo questo caso: quando siamo in mobile e slick è già inizializzato
        $productCarousel.slick('setPosition');
      }
    }, 200);

    $(window).on('load', () => {
      if ($(window).width() <= 1024) {
        $(this.dom.productCarousel).slick(slickSettings);
      }
    });

    $(window).on('resize orientationchange', handleResize);
  }

  // open image zoom //
  openZoom(image) {
    document.body.classList.add("--fixed");
    this.dom.zoomContainer.classList.remove("hidden");
    this.dom.zoomImage.style.backgroundImage = `url(${image.dataset.zoomImage})`;
    const activePicture = this.$component.querySelector('[data-navigation-index="' + image.dataset.index + '"]');
    if(activePicture) {
      const image = activePicture.querySelectorAll('img')[0]
      image.classList.add("--active");
      this.dom.activePicture = image;
    }
  }

  openZoomMobile(imageIndex) {
    document.body.classList.add("--fixed");
    this.dom.zoomContainer.classList.remove("hidden");
    const options = {
      mobileFirst: true,
      prevArrow: this.dom.zoomPrevArrow,
      nextArrow: this.dom.zoomNextArrow,
      responsive: [
        {
          breakpoint: 1024,
          settings: "unslick"
        }
      ]
    };
    $(this.dom.zoomNavigation).slick(options);
  }

  clickOnNavigationCard(image) {
    this.dom.activePicture ? this.dom.activePicture.classList.remove("--active") : '';
    this.dom.zoomImage.style.backgroundImage = `url(${image.dataset.zoomImage})`;
    const activePicture = image.querySelectorAll('img')[0];
    activePicture.classList.add("--active");
    this.dom.activePicture = activePicture;
  }

  handleMouseMove() {
    this.dom.zoomImage.onmousemove = ({ clientY }) => {
      if (typeof clientY !== 'number') {
        console.warn('image-zoom mouse event failed');
        return 0;
      }
      const perc = (clientY / window.innerHeight) * 100;
      const mousePositionPerc = Math.min(Math.max(perc, 0), 100);
      this.dom.zoomImage.style.backgroundPositionY = mousePositionPerc + "%";
    };
  }

  bindEvents() {
    // handle mouse move on desktop
    if(this.dom.zoomImage && window.matchMedia('(min-width: 1024px)').matches) {
      this.handleMouseMove();
    }
    if(this.dom.zoomTriggers) {
      this.dom.zoomTriggers.forEach(image => {
        if (window.matchMedia('(min-width: 1024px)').matches) {
          // desktop behaviour
          image.addEventListener("click", this.openZoom.bind(this, image));
        } else {
          //mobile behaviour
          image.addEventListener("click", this.openZoomMobile.bind(this, image.dataset.index));
        }

      });
    }
    if(this.dom.navigationTriggers && window.matchMedia('(min-width: 1024px)').matches) {
      this.dom.navigationTriggers.forEach(image => {
        image.addEventListener("click", this.clickOnNavigationCard.bind(this, image));
      });
    }
    if(this.dom.zoomClose) {
      this.dom.zoomClose.addEventListener("click", (event) => {
        document.body.classList.remove("--fixed");
        this.dom.zoomContainer.classList.add("hidden");
        this.dom.activePicture ? this.dom.activePicture.classList.remove("--active") : '';
        this.dom.activePicture = null;
        if(window.matchMedia('(max-width: 1024px)').matches) {
          $(this.dom.zoomNavigation).slick('unslick');
        }
      });
    }
  }

  pdpVideoHandler() {
    if(this.dom.videosPdp && this.dom.videosPdp.length > 0){
      this.dom.videosPdp.forEach(videoPdp => {
        brightcovePlayerLoader({
          refNode: videoPdp,
          refNodeInsert: 'prepend',
          accountId: videoPdp.dataset.accountId, //required - A Video Cloud account ID
          playerId: 'default', //required
          videoId: videoPdp.dataset.videoId,
          embedType: 'in-page', //in-page or iframe
          applicationId: "", // The application ID to be applied to the generated embed.
          embedOptions: {
            responsive: {
              aspectRatio: '3:4'
            }
          },
          options: {
            controls: false,
            loop: true,
            muted: true,
            poster: videoPdp.dataset.poster,
          },
        })
        .then(success => {
          const player = success.ref;
          const el = player.el();
          player.controlBar.hide();
          player.titleBar.hide();
          // prevent double click opening fullscreen
          el.addEventListener('dblclick', (e) => {
            e.stopPropagation();
            e.preventDefault();
          }, true);
          const playButton = videoPdp.querySelector("[data-video-play]");
          const pauseButton = videoPdp.querySelector("[data-video-pause]");
          playButton?.addEventListener("click", event => {
            event.preventDefault();
            player.play();
            playButton.classList.add("hidden");
            pauseButton.classList.remove("hidden");
            pauseButton.focus();
          });
          pauseButton?.addEventListener("click", event => {
            event.preventDefault();
            player.pause();
            playButton.classList.remove("hidden");
            pauseButton.classList.add("hidden");
            playButton.focus();
          });
          player.on('pause', event => {
            playButton.classList.remove("hidden");
            pauseButton.classList.add("hidden");
          });
          player.on('play', event => {
            playButton.classList.add("hidden");
            pauseButton.classList.remove("hidden");
          });

          // Set up Intersection Observer
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                player.play().catch(() => {}); // Start playing when visible
              } else {
                player.pause(); // Pause when not visible
              }
            });
          }, {
            threshold: 0.5, // Trigger when 50% of player is visible
          });

          // Observe the player element
          observer.observe(player.el());
        })
        .catch(error => {
          console.warn("Error creating video player.", error);
        });
      });
    }
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.importSlick();
    this.pdpVideoHandler();
    this.initCarousel();
    this.bindEvents();
  }
}
